  // Initial state
  const state = () => ({
    gtmCurrentRefinements: [ ] 
  });
  
  // Getters
  const getters = {
    gtmCurrentRefinements: (state, getters, rootState) => {
      return state.gtmCurrentRefinements;
    },
  };
  
  // Actions
  const actions = {
    setGTMRefinement({ commit, state }, refinemment) {
        commit('setGTMRefinement', { refinemment });
      },
    removeGTMRefinement({ commit, state }, refinemment) {
      commit('removeGTMRefinement', { refinemment });
    },
  };
  
  // Mutations
  const mutations = {
    setGTMRefinement(state, { refinemment }) {
        if(!state.gtmCurrentRefinements || state.gtmCurrentRefinements.length <= 0){
          state.gtmCurrentRefinements = [];
        }
        let index = refinemment && refinemment.length > 0 ? state.gtmCurrentRefinements.indexOf(refinemment) : -1;

        if (index == -1) {
          state.gtmCurrentRefinements.push(refinemment);
        }
      },
    removeGTMRefinement(state, { refinemment }) {
      if(!state.gtmCurrentRefinements || state.gtmCurrentRefinements.length <= 0){
        state.gtmCurrentRefinements = [];
        return;
      }
      let index = refinemment && refinemment.length > 0 ? state.gtmCurrentRefinements.indexOf(refinemment) : -1;
      if (index > -1) {
        state.gtmCurrentRefinements.splice(index, 1);
      }
    }
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }